import { post } from 'store/request';
import store from 'store/index';
import { showApplyDialog } from 'pages/rta';
import { report } from 'store/report';
import { openWin } from 'utils/index';

/**
 * 非标准投放工具授权
 */
const nonStandardAuth = (id: string, setPending: (id: string) => void) => {
  const {
    user: { user },
    application: { list },
  } = store.getState();

  if (id === 'rta') {
    showApplyDialog();
    return id;
  }

  if (list[id].app_auth_type === 1) {
    openWin(`/wechat-oauth?client_id=${id}`);
    return id;
  }

  if (list[id].app_auth_type === 2) {
    openWin(list[id].redirect_uri);
    return id;
  }

  if (user?.user_id && list[id].app_auth_type === 3) {
    setPending(id);
    const params = {
      auth_account_type: user.login_type === 1 ? 'ACCOUNT_TYPE_QQ' : 'ACCOUNT_TYPE_WECHAT',
      client_id: id,
      redirect_uri: list[id].redirect_uri,
      state: list[id].state,
    };
    const win = window.open();
    win.opener = null;
    post('/developer_service/implicit/authorize_batch', params)
      .then((res) => {
        report({ event: 'request-app-auth', client_id: id, url: res.redirect_uri, payload: JSON.stringify(params) });
        win.location.href = res.redirect_uri;
      })
      .catch(win.close)
      .finally(() => setPending(null));
    return id;
  }

  return null;
};

export default nonStandardAuth;
